import { Subscription, SubscriptionPrices } from '@core/models/subscription.models';

export interface SubscriptionState {
  prices: SubscriptionPrices;
  subscription: Subscription;
}
